module.exports = __webpack_public_path__ + "img/682.92e2ee8d.jpg";